import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PurchaseOrderTable from 'src/components/VehicleTrackingDetails/Tables/PurchaseOrderTable';
import { useMediaQuery } from '@mui/system';
import { useNavigate, useParams } from 'react-router-dom';
import VehicleContentTable from 'src/components/VehicleTrackingDetails/Tables/VehicleContentTable';
import PurchaseOrderLineItemTable from 'src/components/VehicleTrackingDetails/Tables/PurchaseOrderLineItemTable';
import { Modal } from 'react-bootstrap';
import CustomMultiSelect from 'src/utils/CustomMultiSelect';
import getColorCode from 'src/utils/GetThemeColor';
import {
  getNextAvailableWorkflowStages,
  skipAndMoveVtToAnotherWs,
} from 'src/redux/Actions/VehicleTracking';
import VehicleTrackingTimeline from 'src/components/VehicleTrackingDetails/Tables/VehicleTrackingTimeline';
import TargetVsActualLogsTab from 'src/components/VehicleTrackingDetails/Tables/TargetVsActualLogsTab';
import QualityCheckReviewTab from 'src/components/VehicleTrackingDetails/QualityCheck/QualityCheckReviewTab';
import QualityCheckTabContent from 'src/components/VehicleTrackingDetails/QualityCheck/QualityCheckTabContent';
import InvoiceTab from 'src/components/VehicleTrackingDetails/Invoice/InvoiceTab';
import { ReactComponent as ActivityLogIcon } from 'src/Images/icons/common/activityLogIcon.svg';
import { Drawer } from '@mui/material';
import VehicleTrackingChangeLog from 'src/components/VehicleTrackingDetails/VehicleTrackingTimeLine/VehicleTrackingChangeLog';
import VehicleTrackingLoadTab from 'src/components/VehicleTrackingDetails/Tables/VehicleTrackingLoadTab';
import LoadLineItemListTab from 'src/components/VehicleTrackingDetails/LoadingStation/LoadLineItemListTab';
import AccessControl from 'src/components/AccessControl';
import { ACTIONS } from 'src/utils/roles/actions';
import { usePermissions } from 'src/utils/hooks/usePermissions';
import VehicleTrackingDeliveryTab from 'src/components/VehicleTrackingDetails/Tables/VehicleTrackingDeliveryTab';
import VehicleTrackingLiveScreen from 'src/components/VehicleTrackingDetails/LiveScreen/VehicleTrackingLiveScreen';
import VehicleTrackingAdditionalDetails from 'src/components/VehicleTrackingDetails/Tables/VehicleTrackingAdditionalDetails';
import ConversationsTab from 'src/components/VehicleTrackingDetails/Conversations/ConversationsTab';

export default function VehicleTrackingDetailSection({
  vehicleFormFunction,
  toggleCreateLoadDrawer,
  createLoadTabActive,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState('2');
  const hasUserSelectedTab = useRef(false);
  const [selectedNextWorkflowStage, setSelectedNextWorkflowStage] =
    useState(null);
  const { hasPermission, isPermissionsLoaded } = usePermissions();
  const authReducer = useSelector((state) => state.AuthReducer);

  const vehicleTrackingDataReducer = useSelector(
    (state) => state?.VehicleTrackingReducer,
  );

  const organisationId = authReducer.userData.organisations?.id;

  const themeColor = authReducer.userData.tenant?.theme;
  const handleChange = (tabId) => {
    hasUserSelectedTab.current = true;
    setActiveTab(tabId);
  };
  const isShreeDurga = authReducer?.userData?.tenant?.name
    ?.toLowerCase()
    .includes('shree durga');
  const [selectedPoIds, setSelectedPoIds] = useState([]);
  const isMobile = useMediaQuery('(max-width:600px)');
  const { workflowStageId, vehicleTrackingNumber } = useParams();
  const requestedStage =
    vehicleTrackingDataReducer?.vehicleTrackingDetails?.requestedStage;
  const vehicleTrackingData =
    vehicleTrackingDataReducer?.vehicleTrackingDetails;
  let shouldDisable = false;

  const { vehicleTrackingDetails } = vehicleTrackingDataReducer;

  const direction = vehicleTrackingDetails?.direction?.id;
  const hasViewLoadPermission = hasPermission(
    ACTIONS.VEHICLE_TRACKING.OUTWARD.VIEW_LOAD,
  );
  const hasCaptureLoadWeightPermission =
    hasPermission(ACTIONS.VEHICLE_TRACKING.OUTWARD.CAPTURE_LOAD_WEIGHT_1) ||
    hasPermission(ACTIONS.VEHICLE_TRACKING.OUTWARD.CAPTURE_LOAD_WEIGHT_2);
  const { superAdmin, organisationAdmin } = authReducer;
  const hasEditDeliveryPermission = hasPermission(
    ACTIONS.VEHICLE_TRACKING.OUTWARD.EDIT_DELIVERY,
  );
  const hasDeliveryTabPermission =
    superAdmin || organisationAdmin || hasEditDeliveryPermission;

  const showInvoiceTab =
    (requestedStage?.allow_vehicle_content_additon ||
      requestedStage?.allow_grn_sync) &&
    direction === 1;

  const hasLiveScreenPermission = hasPermission(
    ACTIONS.VEHICLE_TRACKING.LIVE_SCREEN,
  );

  const [showChangeLog, setShowChangeLog] = useState(false);

  const workflowDropDownInlineStyles = () => ({
    indicatorSeparator: () => ({}),
    option: (provided, state) => ({
      ...provided,
      color: state.isDisabled ? 'lightgray' : 'inherit',
      backgroundColor: state.isSelected ? '#e6f5ff' : 'white',
      fontSize: 14,
    }),
    control: (base) => ({
      ...base,
    }),
    valueContainer: (base) => ({
      ...base,
    }),
    dropdownIndicator: (base) => ({
      ...base,
      color: getColorCode(themeColor),
    }),
    menu: (base) => ({
      ...base,
      zIndex: 2,
    }),

    menuPortal: (base) => ({
      ...base,
      zIndex: 2,
    }),
  });
  useEffect(() => {
    hasUserSelectedTab.current = false;
    setActiveTab('2');
  }, [vehicleTrackingNumber]);

  useEffect(() => {
    if (isShreeDurga) {
      const hasLoadPermission =
        hasViewLoadPermission || hasCaptureLoadWeightPermission;
      const shouldOpenLoadTab =
        !hasUserSelectedTab.current &&
        isPermissionsLoaded &&
        direction === 2 &&
        hasLoadPermission;

      if (shouldOpenLoadTab) {
        setActiveTab('7');
      }
    }
  }, [
    direction,
    hasCaptureLoadWeightPermission,
    hasViewLoadPermission,
    isPermissionsLoaded,
    vehicleTrackingNumber,
  ]);

  useEffect(() => {
    if (!createLoadTabActive) return;

    hasUserSelectedTab.current = true;
    setActiveTab('7');
  }, [createLoadTabActive]);

  useEffect(() => {
    // fetches next available states to skip
    if (
      vehicleTrackingData?.currentWorkflowStageId === null &&
      requestedStage?.workflow_stage_id ===
        vehicleTrackingData?.previousWorkflowStageId &&
      showMoveToNextStageDropdown()
    ) {
      dispatch(
        getNextAvailableWorkflowStages(organisationId, vehicleTrackingNumber),
      );
    }
  }, [
    vehicleTrackingData?.currentWorkflowStageId,
    requestedStage?.workflow_stage_id,
    vehicleTrackingData?.currentWorkflowStageCompleted,
    dispatch,
    organisationId,
    vehicleTrackingNumber,
  ]);
  const options =
    vehicleTrackingDataReducer?.vehicleTrackingWorkflowStagesData?.nextAvailableWorkflowStages?.map(
      (workflowStage, index) => {
        const option = {
          value: workflowStage.id,
          label: workflowStage.name,
          mandatory: workflowStage.mandatory,
          isDisabled: shouldDisable || index === 0,
        };

        if (workflowStage.mandatory && !shouldDisable) {
          shouldDisable = true;
        }
        return option;
      },
    );

  const showMoveToNextStageDropdown = () => {
    if (
      requestedStage?.workflow_stage_id ===
        vehicleTrackingData.previousWorkflowStageId &&
      requestedStage?.allow_next_stage_selection === true &&
      vehicleTrackingData?.currentWorkflowStageId === null
    ) {
      return true;
    }
    return false;
  };

  const handleSendToNextAvailableWsFormSubmit = (e) => {
    e.preventDefault();
    const nextWsStageId = selectedNextWorkflowStage.value;

    dispatch(
      skipAndMoveVtToAnotherWs(
        organisationId,
        vehicleTrackingNumber,
        nextWsStageId,
      ),
    ).then(() => {
      navigate(`/stations/`);
    });
  };

  const handleWorkflowStageDropdownChange = (selectedOption) => {
    setSelectedNextWorkflowStage(selectedOption);
  };

  const toggleChangeLog = (value) => {
    setShowChangeLog(value);
  };

  return (
    <>
      {showMoveToNextStageDropdown() && !isMobile && (
        <div className="vehicle-tracking-detail-tab-title-section mb-3">
          <div className="timeline-header move-stage-section-container rg-10">
            <div className="text-lg">
              Would you like to send this to a different next stage?
            </div>

            <div className="d-flex justify-space-between">
              <div className="flex-grow-1">{renderSelectMoveStage()}</div>
              <div className="flex-grow-1" />
              <button
                className={`vehicle-tracking-detail-move-stage-btn div-align-center theme-background-${themeColor}`}
                type="submit"
                onClick={handleSendToNextAvailableWsFormSubmit}
                disabled={!selectedNextWorkflowStage}
              >
                Move to Selected Stage
              </button>
            </div>
          </div>
        </div>
      )}
      <div
        className={`${isMobile ? 'tracking-data-section-container-mobile' : 'tracking-data-section-container-v2 border-top'}`}
      >
        {/* Tab Headers */}
        <div className="div-flex-row w-100 div-space-between border-bottom tab-view-bg-details">
          <div
            className={`div-flex-row vehicle-tracking-detail-tab-title-section theme-horizontal-scrollable-container-${themeColor} hide-scrollbar`}
          >
            {/* )} */}
            <div
              onClick={() => handleChange('2')}
              className={
                activeTab === '2'
                  ? `theme-tab-active-${themeColor} tab-title icon-btn-none text-sm text-medium-bold`
                  : 'tab-common tab-title vehicle-tracking-detail-tab icon-btn-none text-sm text-medium-bold'
              }
              role="button"
              tabIndex={0}
            >
              <span>Basic Details</span>
            </div>
            {requestedStage?.allow_quality_check && direction === 1 && (
              <div
                onClick={() => handleChange('5')}
                className={
                  activeTab === '5'
                    ? `theme-tab-active-${themeColor} tab-title icon-btn-none text-sm text-medium-bold`
                    : 'tab-common tab-title vehicle-tracking-detail-tab icon-btn-none text-sm text-medium-bold'
                }
                role="button"
                tabIndex={0}
              >
                <span>Quality Check</span>
              </div>
            )}
            {requestedStage?.allow_quality_check && direction === 1 && (
              <div
                onClick={() => handleChange('6')}
                className={
                  activeTab === '6'
                    ? `theme-tab-active-${themeColor} tab-title icon-btn-none text-sm text-medium-bold`
                    : 'tab-common tab-title vehicle-tracking-detail-tab icon-btn-none text-sm text-medium-bold'
                }
                role="button"
                tabIndex={0}
              >
                <span>Quality Check Review</span>
              </div>
            )}
            <div
              onClick={() => handleChange('11')}
              className={
                activeTab === '11'
                  ? `theme-tab-active-${themeColor} tab-title icon-btn-none text-sm text-medium-bold`
                  : 'tab-common tab-title vehicle-tracking-detail-tab icon-btn-none text-sm text-medium-bold'
              }
              role="button"
              tabIndex={0}
            >
              <span>Additional Details</span>
            </div>
            <div
              onClick={() => handleChange('4')}
              className={
                activeTab === '4'
                  ? `theme-tab-active-${themeColor} tab-title icon-btn-none text-sm text-medium-bold`
                  : 'tab-common tab-title vehicle-tracking-detail-tab icon-btn-none text-sm text-medium-bold'
              }
              role="button"
              tabIndex={0}
            >
              <span>Target Vs Actual Logs</span>
            </div>
            {showInvoiceTab && (
              <div
                onClick={() => handleChange('8')}
                className={
                  activeTab === '8'
                    ? `theme-tab-active-${themeColor} tab-title icon-btn-none text-sm text-medium-bold`
                    : 'tab-common tab-title vehicle-tracking-detail-tab icon-btn-none text-sm text-medium-bold'
                }
                role="button"
                tabIndex={0}
              >
                <span className="text-sm">Invoices</span>
              </div>
            )}
            {requestedStage?.show_vendor_details && direction === 1 && (
              <div
                onClick={() => handleChange('1')}
                className={
                  activeTab === '1'
                    ? `theme-tab-active-${themeColor} tab-title icon-btn-none text-sm text-medium-bold`
                    : 'tab-common tab-title vehicle-tracking-detail-tab icon-btn-none text-sm text-medium-bold'
                }
                role="button"
                tabIndex={0}
              >
                <span>Purchase Order Details</span>
              </div>
            )}
            {direction === 2 && (
              <AccessControl
                action={ACTIONS.VEHICLE_TRACKING.OUTWARD.VIEW_LOAD}
              >
                <div
                  onClick={() => handleChange('7')}
                  className={
                    activeTab === '7'
                      ? `theme-tab-active-${themeColor} tab-title icon-btn-none text-sm text-medium-bold`
                      : 'tab-common tab-title vehicle-tracking-detail-tab icon-btn-none text-sm text-medium-bold'
                  }
                  role="button"
                  tabIndex={0}
                >
                  <span>Vehicle Tracking Load</span>
                </div>
              </AccessControl>
            )}
            {direction === 2 && hasDeliveryTabPermission && (
              <div
                onClick={() => handleChange('10')}
                className={
                  activeTab === '10'
                    ? `theme-tab-active-${themeColor} tab-title icon-btn-none text-sm text-medium-bold`
                    : 'tab-common tab-title vehicle-tracking-detail-tab icon-btn-none text-sm text-medium-bold'
                }
                role="button"
                tabIndex={0}
              >
                <span>Delivery</span>
              </div>
            )}
            {vehicleTrackingDetails?.requestedStage
              ?.allow_issue_stamp_addition && (
              <div
                onClick={() => handleChange('9')}
                className={
                  activeTab === '9'
                    ? `theme-tab-active-${themeColor} tab-title icon-btn-none text-sm text-medium-bold`
                    : 'tab-common tab-title vehicle-tracking-detail-tab icon-btn-none text-sm text-medium-bold'
                }
                role="button"
                tabIndex={0}
              >
                <span>Issue Stamp</span>
              </div>
            )}
            {hasLiveScreenPermission && (
              <div
                onClick={() => handleChange('12')}
                className={
                  activeTab === '12'
                    ? `theme-tab-active-${themeColor} tab-title icon-btn-none text-sm text-medium-bold`
                    : 'tab-common tab-title vehicle-tracking-detail-tab icon-btn-none text-sm text-medium-bold'
                }
                role="button"
                tabIndex={0}
              >
                <span>Live</span>
              </div>
            )}
            <div
              onClick={() => handleChange('13')}
              className={
                activeTab === '13'
                  ? `theme-tab-active-${themeColor} tab-title icon-btn-none text-sm text-medium-bold`
                  : 'tab-common tab-title vehicle-tracking-detail-tab icon-btn-none text-sm text-medium-bold'
              }
              role="button"
              tabIndex={0}
            >
              <span>Conversations</span>
            </div>
            <div
              onClick={() => handleChange('3')}
              className={
                activeTab === '3'
                  ? `theme-tab-active-${themeColor} tab-title icon-btn-none text-sm text-medium-bold`
                  : 'tab-common tab-title vehicle-tracking-detail-tab icon-btn-none text-sm text-medium-bold'
              }
              role="button"
              tabIndex={0}
            >
              <span>Timeline</span>
            </div>
          </div>

          <div className="div-flex-row div-align-center horizontal-padding-10 cg-10">
            <button
              className="icon-btn-none"
              aria-label="open log"
              onClick={toggleChangeLog}
            >
              <ActivityLogIcon className="icon-size-xxl" />
            </button>
          </div>
        </div>

        {/* Tab Content */}
        {activeTab === '1' && (
          <div
            className={`vehicle-tracking-detail-tab-container padding-left-right theme-scrollable-container-${themeColor}`}
          >
            <PurchaseOrderTable
              selectedPoIds={selectedPoIds}
              setSelectedPoIds={setSelectedPoIds}
            />
            <PurchaseOrderLineItemTable selectedPoIds={selectedPoIds} />
          </div>
        )}
        {activeTab === '2' && (
          <div
            className={`vehicle-tracking-detail-tab-container theme-scrollable-container-${themeColor}`}
          >
            <VehicleContentTable
              toggleAddVehicleContentDrawer={vehicleFormFunction}
            />
          </div>
        )}
        {activeTab === '4' && (
          <div
            className={`vehicle-tracking-detail-tab-container theme-scrollable-container-${themeColor}`}
          >
            <TargetVsActualLogsTab />
          </div>
        )}
        {activeTab === '5' && (
          <div
            className={`vehicle-tracking-detail-tab-container padding-left-right theme-scrollable-container-${themeColor}`}
          >
            {' '}
            <QualityCheckTabContent />
          </div>
        )}
        {activeTab === '6' && (
          <div
            className={`vehicle-tracking-detail-tab-container padding-left-right theme-scrollable-container-${themeColor}`}
          >
            <QualityCheckReviewTab />
          </div>
        )}
        {activeTab === '7' && (
          <div
            className={`vehicle-tracking-detail-tab-container padding-left-right theme-scrollable-container-${themeColor}`}
          >
            <VehicleTrackingLoadTab
              toggleCreateLoadDrawer={toggleCreateLoadDrawer}
              createLoadTabActive={createLoadTabActive}
            />
          </div>
        )}
        {activeTab === '3' && (
          <VehicleTrackingTimeline workFlowStageId={workflowStageId} />
        )}
        {activeTab === '8' && showInvoiceTab && (
          <div
            className={`vehicle-tracking-detail-tab-container padding-left-right theme-scrollable-container-${themeColor}`}
          >
            <InvoiceTab />
          </div>
        )}
        {activeTab === '9' && (
          <div
            className={`vehicle-tracking-detail-tab-container padding-left-right theme-scrollable-container-${themeColor}`}
          >
            <LoadLineItemListTab />
          </div>
        )}
        {activeTab === '10' && direction === 2 && hasDeliveryTabPermission && (
          <div className={`theme-scrollable-container-${themeColor}`}>
            <VehicleTrackingDeliveryTab />
          </div>
        )}
        {activeTab === '12' && hasLiveScreenPermission && (
          <div
            className={`vehicle-tracking-detail-tab-container theme-scrollable-container-${themeColor}`}
          >
            <VehicleTrackingLiveScreen />
          </div>
        )}
        {activeTab === '11' && (
          <div
            className={`vehicle-tracking-detail-tab-container theme-scrollable-container-${themeColor}`}
          >
            <VehicleTrackingAdditionalDetails />
          </div>
        )}
        {activeTab === '13' && (
          <div
            className={`vehicle-tracking-detail-tab-container theme-scrollable-container-${themeColor}`}
          >
            <ConversationsTab />
          </div>
        )}
      </div>
      <Modal
        show={showMoveToNextStageDropdown() && isMobile}
        onHide={() => {}}
        centered
      >
        <Modal.Body>
          <div className="d-flex flex-column rg-10">
            <div className="text-lg text-center text-medium-bold">
              Would you like to send this to a different next stage?{' '}
            </div>
            {renderSelectMoveStage()}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className={`vehicle-tracking-detail-move-stage-btn div-align-center theme-background-${themeColor}`}
            onClick={handleSendToNextAvailableWsFormSubmit}
            disabled={!selectedNextWorkflowStage}
          >
            Move to Selected State
          </button>
        </Modal.Footer>
      </Modal>

      <Drawer
        anchor="right"
        open={Boolean(showChangeLog)}
        onClose={() => toggleChangeLog(false)}
        ModalProps={{ keepMounted: false }}
        sx={{ zIndex: 1 }}
        PaperProps={{
          sx: {
            width: isMobile ? '100%' : '30%',
          },
        }}
      >
        <VehicleTrackingChangeLog toggleChangeLog={toggleChangeLog} />
      </Drawer>
    </>
  );

  function renderSelectMoveStage() {
    return (
      <div className="input-wrapper">
        <CustomMultiSelect
          name="stage_id"
          isMulti={false}
          className="form-input-section p-0"
          classNamePrefix="react-select"
          placeholder="Select Stage"
          options={options}
          onChange={handleWorkflowStageDropdownChange}
          styles={workflowDropDownInlineStyles()}
        />
      </div>
    );
  }
}
